import PlanFeaturesItemOffering from './plan-features-item-offering';

import { PlanFeature as PlanFeatureType, PlanOffering } from '../../plan.types';
import { PlanFeaturesItemContainer } from './plan-features-item.styles';

type PlanFeaturesProps = {
  feature: PlanFeatureType;
  offerings: PlanOffering[];
};

export default function PlanFeaturesItem({ feature, offerings }: PlanFeaturesProps) {
  return (
    <PlanFeaturesItemContainer className={`offerings-${offerings.length}`}>
      <div className="feature" dangerouslySetInnerHTML={{ __html: feature.name }}></div>
      {offerings.map((offering) => (
        <PlanFeaturesItemOffering feature={feature} offering={offering} key={`${feature.id}-${offering.id}`} />
      ))}
    </PlanFeaturesItemContainer>
  );
}
